
const Privacy = () => {
  return (
    <div className="privacy-container">
      <header>
        <h1>PRIVACY POLICY</h1>
      </header>

      <main>
        {/* Section 1 */}  
        <section>
          <h2>1. Introduction</h2>
          <p>
            Checkoff Finance Company Limited ("Company") is dedicated to protecting and
            respecting customers’ privacy. We are committed to being transparent about how we
            collect, process, share and manage data about you (our customers and other natural
            persons where applicable). By accessing or subscribing to any of our products and
            services, customers provide certain personally identifiable information.
          </p>
          <p>
            This document details the policies of the Company guiding the collection, use,
            storage, destruction and disclosure of this personally identifiable information and by
            continuing to visit our website and our portals, you accept and consent to the
            practices described in this policy.
          </p>
        </section>

        {/* Section 2 */}
        <section>
          <h2>2. Information collection</h2>
          <p>
            We may collect information from a range of sources and it may relate to any of our
            products or services we currently provide or may have provided in the past. In order
            for us to provide you with a service and to meet your needs, we need to collect
            personal data. We collect information you provide us via forms, phone calls, and
            correspondence by mail or email, as well as social media, where necessary.
          </p>
          <p>The information we collect may include but is not limited to:</p>
          <ul>
            <li>First, middle and last name</li>
            <li>Email address</li>
            <li>Contact address</li>
            <li>Bank Verification Number (BVN)</li>
            <li>Phone number</li>
            <li>Signature</li>
            <li>Date of birth</li>
            <li>Gender</li>
            <li>Employment details</li>
            <li>Identification documents and similar contact data</li>
            <li>Services desired/required and transactions relating to the services</li>
          </ul>
          <p>We may also collect information about you from third parties and other service partners.</p>
        </section>

        {/* Section 3 */}
        <section>
          <h2>3. Use of personal information</h2>
          <p>The Company will process your personal information for the following purposes:</p>
          <ol>
            <li>To offer and provide our Products and Services tailored to meet your unique needs;</li>
            <li>To fulfil the terms of any service contract(s) you might have with us;</li>
            <li>To improve your service experience with us;</li>
            <li>To conduct our business;</li>
            <li>To manage our relationship with you;</li>
            <li>To comply with Laws and Regulations;</li>
            <li>To check credit history and update credit report with Credit Bureaus;</li>
            <li>To update your records;</li>
            <li>To develop statistics as may be required;</li>
            <li>To comply with our Internal Policies;</li>
            <li>
              To communicate with you when necessary and send important news about your account,
              request your feedback;
            </li>
            <li>
              To deliver advertising to you directly or on our websites, provide updates on special
              deals and offers that might interest you.
            </li>
          </ol>
        </section>

        {/* Section 4 */}
        <section>
          <h2>4. Transfer and security of information</h2>
          <p>
            Save as related to the provision of financial services and meeting legal, regulatory,
            contractual, and other uses incidental to these, we will not share your personal data
            with a third party. Where it becomes necessary to do so, adequate security measures
            will be taken to protect the information from access by recipients other than those for
            which it is intended.
          </p>
          <p>
            We will take reasonable precautions and follow industry best practices to ensure that
            your information is not inappropriately lost, misused, accessed, disclosed, altered or
            destroyed. No transfer of your Personal Information will take place to an organization
            or a country unless there are adequate controls in place including the security of your
            information and other personal information.
          </p>
        </section>

        {/* Section 5 */}
        <section>
          <h2>5. Information sharing and disclosure</h2>
          <p>
            The Company, in efforts to provide you with excellent products and services, may need
            to share your information with third parties; this will be done in line with relevant
            regulations and law. We may share your information in order to provide you with the
            products or services you have requested.
          </p>
          <p>
            We may also share your information where we have a public or legal duty to do so, when
            we need it to conclude regulatory reporting and when we have requested and received
            your permission to share it.
          </p>
        </section>

        {/* Section 6 */}
        <section>
          <h2>6. General principles of processing of personal information</h2>
          <p>
            The Company is committed to maintaining the principles in the Nigeria Data Protection
            Act (NDPA) 2023 regarding the processing of Personal Information. To demonstrate this
            commitment as well as our aim of creating a positive privacy culture within the Company,
            the Company adheres to the following basic principles:
          </p>
          <ul>
            <li>Personal information shall be processed lawfully, fairly and in a transparent manner.</li>
            <li>Personal information must be accurate and kept up-to-date.</li>
            <li>
              The Company limits personal information collection and usage to data that is relevant,
              adequate, and absolutely necessary for carrying out the purpose for which the
              information is processed.
            </li>
            <li>
              The Company shall establish adequate controls in order to protect the integrity and
              confidentiality of personal information.
            </li>
            <li>
              All personal information shall be retained, stored and destroyed by the Company in line
              with legislative and regulatory guidelines.
            </li>
            <li>
              The Company demonstrates accountability in line with the NDPR obligations by monitoring
              and continuously improving data privacy practices.
            </li>
          </ul>
        </section>

        {/* Section 7 */}
        <section>
          <h2>7. Children’s privacy</h2>
          <p>
            We do not knowingly collect personally identifiable information from anyone under the
            age of 18. If you are a parent or guardian and you are aware that your children have
            provided us with Personal Information, please contact us. If we become aware that we
            have collected Personal Information from children without verification of parental
            consent, we will take steps to remove that information from our servers.
          </p>
        </section>

        {/* Section 8 */}
        <section>
          <h2>8. Personal information retention period</h2>
          <p>
            We will only keep your personal information for as long as it is necessary for the
            purposes set out in this Privacy Policy, unless a longer retention period is required or
            permitted by law (such as tax, accounting or other legal requirements).
          </p>
        </section>

        {/* Section 9 */}
        <section>
          <h2>9. Your privacy rights</h2>
          <p>The following rights are available to you under this Policy:</p>
          <ul>
            <li><strong>Right to be informed:</strong> How the Company will use your Personal Information.</li>
            <li>
              <strong>Right of access:</strong> You may request for access to your personal
              information held by the Company or request that it be made available to a third party.
            </li>
            <li>
              <strong>Right to rectification:</strong> You may request to rectify or update your
              personal information with us at any time.
            </li>
            <li>
              <strong>Right to erasure/deletion:</strong> You may request that your personal
              information be deleted, except where retention is required by law or regulation.
            </li>
            <li>
              <strong>Right to restrict processing:</strong> You may restrict the processing of your
              personal information by the Company.
            </li>
            <li>
              <strong>Right to withdraw consent:</strong> You may elect to withdraw your consent at
              any time. Save where there is a legal or operational reason to continue with the
              processing, the Company shall discontinue upon receipt of your notice withdrawing
              consent.
            </li>
          </ul>
        </section>

        {/* Section 10 */}
        <section>
          <h2>10. Changes to this privacy policy</h2>
          <p>
            We may update this policy from time to time. Where there are changes in the way we use
            your personal information we will notify you by posting a prominent notice on our
            website.
          </p>
        </section>

        {/* Section 11 */}
        <section>
          <h2>11. Contact and communication</h2>
          <p>If you would like further information on this Policy, or if you wish to contact us:</p>
          <p>
            No 75 Mobolaji Bank Anthony Way, Ikeja, Lagos <br />
            Email:{" "}
            <a href="mailto:customerservice@checkoff.loans">
              customerservice@checkoff.loans
            </a>
          </p>
        </section>
      </main>
    </div>
  );
};

export default Privacy;
